import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
	name: "category",
	initialState: {
		loadingCategory: false,
		error: null,
		selectedCategory: null,
	},
	reducers: {
		getCategory(state, action) {
			return { ...state, loadingCategory: true };
		},

		setCategory(state, action) {
			const categoryData = action.payload;
			return {
				...state,
				loadingCategory: false,
				...categoryData,
			};
		},
		getCategoryFail(state, action) {
			const error = action.payload;
			return { ...state, error: { ...error }, loadingCategory: false };
		},
		getSelectedCategory(state, action) {
			return { ...state, loadingCategory: true };
		},
		setSelectedCategory(state, action) {
			const categoryData = action.payload;
			return {
				...state,
				selectedCategory: { ...categoryData },
			};
		},
	},
});

export const {
	getCategory,
	setCategory,
	getCategoryFail,
	setSelectedCategory,
	getSelectedCategory,
} = categorySlice.actions;

export default categorySlice.reducer;
